import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import { docApi } from './docApi';
import { mediaApi } from './mediaApi';

export const store = configureStore({
  reducer: {
    user: userReducer,
    [docApi.reducerPath]: docApi.reducer,
    [mediaApi.reducerPath]: mediaApi.reducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(docApi.middleware).concat(mediaApi.middleware)
});
